import {
  Box,
  Button,
  Chip,
  ClickAwayListener,
  Dialog,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import { ListBase, useListContext, useTranslate } from "react-admin";
import { useContext, useEffect, useState } from "react";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import CreateIcon from "@material-ui/icons/Create";
import DialogCloseButton from "./DialogCloseButton";
import { PaymentCreateContext } from "../pages/payment/payment-addproduct/PaymentCreateContext";
import ProductButton from "./ProductButton";
import ProductTypeBar from "./ProductTypeBar";
import React from "react";
import SearchBarwithButton from "./SearchBarwithButton";
import SfBreadcrumb from "../components/SfBreadcrumbs";
import discountImage from "../assets/icons/discount_tran.png";
import { getMemberType } from "../utils";
import heartImage from "../assets/icons/heart.png";
import { makeStyles } from "@material-ui/core";
import mobileImage from "../assets/icons/temp/noimage.png";
import moment from "moment";
import settings from "../utils/settings";

//"../pages/payment/actions/index";
const useStyles = makeStyles((theme) => ({
  scrollbar: {
    width: 1,
  },
  allContainer: {
    width: "100%",
    height: "100%",
    marginTop: theme.layout.defaultMarginTop,
    overflowX: "hidden",
    overflowY: "hidden",
    display: "flex",
  },
  breadcrumb: {
    alignSelf: "start",
  },
  productTypeGrid: {
    flexDirection: "column",
    display: "flex",
    overflow: "auto",
    width: 138,
  },
  productPanelGrid: {
    flexGrow: 1,
    backgroundColor: theme.default.normal.backgroundColor,
    overflowY: "hidden",
    overflowX: "hidden",
    marginLeft: -20,
    maxHeight: "95vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: 540,
  },
  productPanelContainer: {
    width: "100%",
    flex: "1 0 auto",
    display: "flex",
    flexDirection: "column",
  },
  productPanel_topBar: {
    width: "100%",
    height: 80,
    display: "grid",
    gridTemplateColumns: "auto 80px 80px",
    //justifyContent: "space-between",
    alignItems: "center",
    marginTop: 1,
  },
  chip: {
    minWidth: 20,
    maxWidth: 100,
    margin: 6,
    backgroundColor: theme.midGray,
    color: theme.darkGray,
    border: 0,
  },
  chip_select: {
    minWidth: 20,
    maxWidth: 100,
    margin: 6,
    color: theme.white,
    backgroundColor: theme.brown,
    "&:hover, &:focus, &:active": {
      backgroundColor: theme.brown + "!important",
    },
  },
  productPanel_midBar: {
    flexGrow: 1,
    marginTop: 2,

    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, 180px)",
    justifyItems: "center",
    //justifyContent: "center",
    justifyContent: "space-around",
    alignContent: "start",
    rowGap: "10px",
    overflow: "auto",
    width: "98%",
    marginLeft: 10,
    height: 1,

    "&::-webkit-scrollbar": {
      width: theme.scrollbar.width,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.scrollbar.thumbColor,
    },
  },
  searchBar: {
    width: "70%",
    height: 50,
    marginLeft: 20,
    marginTop: 8,
  },
  searchBar_searchButton: {
    width: 80,
    height: 40,
  },

  iconButton: {
    maxWidth: 54,
    maxHeight: 54,
    minWidth: 54,
    minHeight: 54,
    padding: 0,
    width: 54,
    height: 54,
    marginLeft: 10,
    marginTop: 4,
  },
  iconButton_image: {
    width: 38,
    height: 38,
  },
  iconOfferButton_image: {
    width: 30,
    height: 25,
  },
  qrButtonContainer: {
    width: "100%",
    height: 55,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.default.normal.backgroundColor,
  },
  qrButton: {
    width: 511,
    height: 33,
  },
}));

const RecommendedProducts = React.memo((props) => {
  const [state, dispatch] = useContext(PaymentCreateContext);
  const [recommendedProducts, setRecommendedProducts] = useState([]);
  const { token } = settings();
  const translate = useTranslate();
  useEffect(() => {
    if (state.items && process.env.REACT_APP_RECOMMEND_API_ENDPOINT) {
      if (state.items.length === 0) {
        return;
      }
      if (state.items.some((item) => item.qty === null || item.qty === 0)) {
        return;
      }
      if (state.items.some((item) => item.qty < 0)) {
        return;
      }

      let memberPhone = null;
      try {
        memberPhone = JSON.parse(
          localStorage.getItem("memberPayment")
        )?.phone?.split("|")[0];
      } catch (e) {}
      const phone = memberPhone || "Guest";
      const productId = state.items[state.items.length - 1].productId;
      console.log(state.items);
      const periods = [
        { text: "Early Morning", start: 0, end: 4 },
        { text: "Morning", start: 5, end: 11 },
        { text: "Afternoon", start: 12, end: 15 },
        { text: "Evening", start: 16, end: 18 },
        { text: "Night", start: 19, end: 21 },
        { text: "Late Night", start: 22, end: 24 },
      ];
      const shift = (() => {
        const hour = moment().hour();
        for (const period of periods) {
          if (hour >= period.start && hour <= period.end) {
            return period.text;
          }
        }
        return "Late Night";
      })();
      const dayOfWeek = moment().format("dddd");
      fetch(
        `${process.env.REACT_APP_RECOMMEND_API_ENDPOINT}/recommendation?phone=${phone}&product_id=${productId}&shift=${shift}&day_of_week=${dayOfWeek}&top_n=5`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      ).then(async (response) => {
        const result = await response.json();
        const resultList = [];
        for (let i = 0; i < result?.payload?.recommenders.length; i++) {
          if (result?.payload?.recommenders[i].product_id === productId) {
            continue;
          }
          const productResult = await fetch(
            `${process.env.REACT_APP_API_ENDPOINT}/products/${result?.payload?.recommenders[i].product_id}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
            }
          );

          try {
            resultList.push((await productResult.json()).payload?.product);
            if (resultList.length >= 3) break;
          } catch (e) {
            console.log(e);
          }
        }
        setRecommendedProducts(resultList);
      });
    }
  }, [JSON.stringify(state.items)]);

  if (recommendedProducts?.length === 0) return null;
  return (
    <Box
      style={{
        width: "100%",
        background: "#FA9917",
        padding: 2,
        boxSizing: "border-box",
        borderRadius: "13px 13px 0 0",
      }}
    >
      <Typography align="center" variant="h4" style={{ color: "white" }}>
        {translate("ra.text.aiRecommendation")}
      </Typography>
      <Box
        style={{
          display: "grid",
          gridTemplateColumns: "33% 33% 34%",
          justifyItems: "center",
        }}
      >
        {recommendedProducts?.map((item, index) => {
          //return <Typography>{item.name}</Typography>;

          return (
            <ProductButton
              key={index}
              url={item.image_url ? item.image_url : mobileImage}
              name={item.name}
              id={item.code ?? ""}
              price={item.retail_price}
              onClick={(e) => {
                e.preventDefault();
                return dispatch({
                  type: "ADD_PRODUCT",
                  payload: item,
                  customPrice: null,
                  aiRecommended: true,
                });
              }}
              onClickView={() =>
                dispatch({
                  type: "SET_VIEW_ITEM",
                  payload: item,
                })
              }
            />
          );
        })}
      </Box>
    </Box>
  );
});

const ProductSelector = React.memo((props) => {
  const { selectedCatIndex, setSelectedCatIndex } = props;

  const ProductImagePanel = (imgPanelProps) => {
    const classes = useStyles();
    // const { loading } = useListContext();

    imgPanelProps = {
      selectedCatIndex,
      setSelectedCatIndex,
      ...imgPanelProps,
    };

    return (
      <Box className={classes.allContainer}>
        <Box className={classes.productTypeGrid}>
          <ProductTypeBar {...imgPanelProps} />
        </Box>
        <Box className={classes.productPanelGrid}>
          <SfBreadcrumb
            path={`/Payment/&user/Add Product`}
            className={classes.breadcrumb}
          />
          <ProductPanel />
          {/* <RecommendedProducts /> */}
        </Box>
      </Box>
    );
  };

  return (
    <>
      <ListBase
        {...props}
        filter={{ status: "Active" }}
        basePath="/products"
        component="div"
        perPage={200}
        resource="products"
      >
        <ProductImagePanel {...props} />
        <ProductDetailView />
      </ListBase>
    </>
  );
});

const ProductPanel = React.memo(() => {
  const classes = useStyles();

  return (
    <Box className={classes.productPanelContainer}>
      <SearchBar className={classes.productPanel_topBar} />
      <SubCatBar />
      <ImageProductList className={classes.productPanel_midBar} />
    </Box>
  );
});

const SubCatBar = () => {
  const classes = useStyles();
  const [state] = useContext(PaymentCreateContext);
  const { setFilters, filterValues } = useListContext();

  const handleChipClick = (id) => {
    if (id === filterValues.category_id) {
      return setFilters({});
    }
    return setFilters({ category_id: id });
  };
  return (
    <Box
      style={{
        display: "flex",
        flexWrap: "wrap",
        //  maxHeight: 50,
        //    width: "100%",
        maxHeight: 80,
        overflowY: "auto",
        overflowX: "hidden",
        marginLeft: 16,
        marginBottom: 5,
      }}
    >
      {state.categories.map((cat, index) => (
        <Chip
          key={index}
          clickable
          className={
            filterValues.category_id && filterValues.category_id === cat.id
              ? classes.chip_select
              : classes.chip
          }
          label={cat.name.slice(0, 10)}
          onClick={() => handleChipClick(cat.id)}
        />
      ))}
    </Box>
  );
};

const SearchBar = ({ className }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const [state, dispatch] = useContext(PaymentCreateContext);
  const [searchText, setSearchText] = useState("");
  const {
    setFilters /*, filterValues  we will cancel all previous filters with searchbar*/,
  } = useListContext();

  return (
    <Box className={className}>
      <SearchBarwithButton
        buttonLabel={translate("ra.text.search")}
        placeholder={translate("ra.text.search_products")}
        onChange={(e) => setSearchText(e.target.value)}
        onSearch={() => {
          if (searchText === "") {
            setFilters({});
          } else setFilters({ keyword: searchText });
        }}
      />

      <Button
        color="primary"
        className={classes.iconButton}
        onClick={() => {
          dispatch({
            type: "SHOW_DISCOUNT",
          });
        }}
        disabled={state.items.length <= 0}
        variant="contained"
      >
        <img
          src={discountImage}
          className={classes.iconButton_image}
          alt="discount"
          style={{ pointerEvents: "none" }}
        />
      </Button>
      <Button
        color="primary"
        className={classes.iconButton}
        variant="contained"
        onClick={() => {
          dispatch({
            type: "SHOW_OFFERS",
          });
        }}
        disabled={state.items.length <= 0 || getMemberType(state) === "guest"}
      >
        <img
          src={heartImage}
          className={classes.iconOfferButton_image}
          alt="heart"
          style={{ pointerEvents: "none" }}
        />
      </Button>
    </Box>
  );
};

const ImageProductList = React.memo(({ className }) => {
  const { branchId } = settings();
  const [, dispatch] = useContext(PaymentCreateContext);
  const { ids, data } = useListContext();
  const translate = useTranslate();

  if (!branchId) {
    return (
      <Typography align="center">
        {translate("ra.text.pleaseSelectBranch")}
      </Typography>
    );
  }

  return (
    <>
      {ids.length === 0 && (
        <Typography align="center">
          {translate("ra.text.noProducts")}
        </Typography>
      )}
      <Box className={className}>
        {ids.map((id, index) => {
          return (
            <ProductButton
              key={index}
              url={data[id].image_url ? data[id].image_url : mobileImage}
              name={data[id].name}
              id={data[id].code ?? ""}
              price={data[id].retail_price}
              onClick={(e) => {
                e.preventDefault();
                return dispatch({
                  type: "ADD_PRODUCT",
                  payload: data[id],
                  customPrice: null,
                });
              }}
              onClickView={() =>
                dispatch({
                  type: "SET_VIEW_ITEM",
                  payload: data[id],
                })
              }
            />
          );
        })}
      </Box>
    </>
  );
});

const useProductDetailStyles = makeStyles((theme) => {
  return {
    paper: {
      width: 400,
      height: 500,
      margin: 0,
      borderRadius: 12,
    },
    media: {
      width: 400,
      height: 185,
    },
    topbar: {
      width: 400,
      height: 95,
      backgroundColor: theme.layout.nonSelected.backgroundColor,
      padding: 13,
      boxSizing: "border-box",
      flexDirection: "row",
      display: "flex",
      justifyContent: "space-between",
    },
    topbarLeftContainer: { width: 250 },
    topbarRightContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      width: 160,
    },
    quantityContainer: {
      marginTop: 7,
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-around",
      alignItems: "baseline",
      width: 100,
    },
    quantityButton: {
      maxWidth: 22,
      minWidth: 22,
      height: 22,
      padding: 0,
      fontSize: 20,
      backgroundColor: theme.white,
      borderRadius: 0,
    },
    quantityText: {
      fontSize: 16,
      fontWeight: "bolder",
    },
    price: {
      marginTop: 10,
      marginRight: 5,
      fontSize: 18,
    },
    productId: {
      fontSize: 9,
      fontWeight: "lighter",
      lineHeight: "10px",
    },
    descriptionTopic: {
      fontSize: 10,
      fontWeight: "bolder",
    },
    description: {
      fontSize: 10,
    },
    middlebar: {
      height: 160,
      padding: 20,
      boxSizing: "border-box",
    },
    actionbar: {
      display: "flex",
      padding: 0,
      boxSizing: "border-box",
      height: 60,
    },
    button: {
      flexGrow: 1,
      fontSize: 20,
      width: "50%",
      margin: 0,
    },
    buttonBorderLeft: {
      borderRadius: "0 0 0 8px",
    },
    buttonBorderRight: {
      borderRadius: "0 0 8px 0",
    },
  };
});

const ProductDetailView = () => {
  const classes = useProductDetailStyles();
  const [state, dispatch] = useContext(PaymentCreateContext);

  const [addNum, setAddNum] = useState(1);
  const [customPrice, setCustomPrice] = useState(0);
  const translate = useTranslate();
  const [editCustomPrice, setEditCustomPrice] = useState(false);
  const { currency } = settings();
  useEffect(() => {
    setCustomPrice(state.viewItem?.retail_price);
  }, [state]);
  if (!state.viewItem) return null;
  const increaseQuantity = () => {
    if (addNum < 100) setAddNum(addNum + 1);
  };

  const decreaseQuantity = () => {
    if (addNum > 0) setAddNum(addNum - 1);
  };

  const onClose = () => {
    //setCustomPrice(state.viewItem.retail_price);
    dispatch({
      type: "SET_VIEW_ITEM",
      payload: null,
    });
  };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={state.viewItem}
      classes={{ paper: classes.paper }}
    >
      <DialogCloseButton frame onClose={onClose} />
      <Card>
        <CardMedia
          className={classes.media}
          image={state.viewItem.image_url}
          title={state.viewItem.name}
        />
        <CardContent style={{ padding: 0 }}>
          <Box className={classes.topbar}>
            <Box className={classes.topbarLeftContainer}>
              <Typography
                gutterBottom
                variant="h4"
                style={{
                  display: "-webkit-box",
                  overflow: "hidden",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 2,
                }}
              >
                {state.viewItem.name}
              </Typography>
              <Typography gutterBottom className={classes.productId}>
                {state.viewItem.code}
              </Typography>
              <Typography gutterBottom className={classes.productId}>
                {state.viewItem.hashtags?.join(", ")}
              </Typography>
            </Box>
            <Box className={classes.topbarRightContainer}>
              <Box className={classes.quantityContainer}>
                <Button
                  className={classes.quantityButton}
                  onClick={decreaseQuantity}
                >
                  -
                </Button>
                <Typography className={classes.quantityText}>
                  {addNum}
                </Typography>
                <Button
                  className={classes.quantityButton}
                  onClick={increaseQuantity}
                >
                  +
                </Button>
              </Box>

              {editCustomPrice ? (
                <ClickAwayListener
                  onClickAway={() => {
                    setEditCustomPrice(false);
                    //setCustomPrice(state.viewItem.retail_price);
                  }}
                >
                  <TextField
                    inputProps={{
                      style: {
                        height: 30,
                        padding: "0 14px",
                      },
                    }}
                    style={{
                      marginTop: 5,
                    }}
                    variant="outlined"
                    type="number"
                    value={customPrice}
                    onChange={(e) => setCustomPrice(parseInt(e.target.value))}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Typography>{currency}</Typography>
                        </InputAdornment>
                      ),
                    }}
                    autoFocus
                  />
                </ClickAwayListener>
              ) : (
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    gutterBottom
                    variant="h4"
                    component="h2"
                    align="right"
                    className={classes.price}
                  >
                    {/* {currency} {state.viewItem.retail_price.toLocaleString()} */}
                    {currency} {customPrice}
                  </Typography>
                  <IconButton
                    onClick={() => setEditCustomPrice(true)}
                    style={{ width: 15, height: 15 }}
                  >
                    <CreateIcon color="primary" />
                  </IconButton>
                </Box>
              )}

              {/* 

              <Typography
                gutterBottom
                variant="h4"
                component="h2"
                align="right"
                className={classes.price}
              >
                {currency}{" "}
                {Number(state.viewItem.retail_price).toLocaleString()}
              </Typography> */}
            </Box>
          </Box>
          <Box className={classes.middlebar}>
            <Typography
              variant="body1"
              className={classes.descriptionTopic}
              component="p"
            >
              {translate("ra.text.description")}
            </Typography>
            <Typography
              variant="body1"
              className={classes.description}
              component="p"
            >
              {state.viewItem.desc}
            </Typography>
          </Box>
        </CardContent>
        <Box className={classes.actionbar}>
          <Button
            className={[classes.button, classes.buttonBorderLeft]}
            variant="contained"
            color="secondary"
            onClick={() => {
              dispatch({
                type: "SET_VIEW_ITEM",
                payload: null,
              });
              setAddNum(1);
              return;
            }}
          >
            {translate("ra.action.close")}
          </Button>
          <Button
            className={[classes.button, classes.buttonBorderRight]}
            variant="contained"
            color="primary"
            disabled={
              addNum <= 0 || customPrice === "" || customPrice <= 0
                ? true
                : false
            }
            onClick={() => {
              dispatch({
                type: "ADD_PRODUCT",
                payload: state.viewItem,
                qty: addNum,
                customPrice: customPrice,
              });
              dispatch({
                type: "SET_VIEW_ITEM",
                payload: null,
              });
              setAddNum(1);
              return;
            }}
          >
            {translate("ra.text.addProduct.addtoBasket")}
          </Button>
        </Box>
      </Card>
    </Dialog>
  );
};

export default ProductSelector;
